import { render } from "./editFAQ.vue?vue&type=template&id=7d649b41"
import script from "./editFAQ.vue?vue&type=script&lang=js"
export * from "./editFAQ.vue?vue&type=script&lang=js"

import "./editFAQ.vue?vue&type=style&index=0&id=7d649b41&lang=less"
script.render = render

export default script